import toWaterBalanceSeries from 'helper/Meteorology/Agro/waterBalanceSeries';
import { GetSequentialGraphResponse, SequentialGraph } from 'types/Meteorology/Agro/WaterBalanceSequential/DetailedView/getGraph';
import { WBSequentialDVOptions, WBSequentialDVOptionsResponse } from 'types/Meteorology/Agro/WaterBalanceSequential/DetailedView/getOptions';

export default function transformGetOptionsResponse(
  response: WBSequentialDVOptionsResponse,
): WBSequentialDVOptions {
  const { data } = response;

  return {
    soilTypes: data.tipos_solo,
    variables: data.variaveis
      .filter((variable) => variable.nome.toLowerCase() !== 'etc'
      && variable.nome.toLowerCase() !== 'graus-dia')
      .map((variable) => ({
        id: variable.id,
        name: variable.nome,
        label: variable.label,
      })),
    startDate: data.periodos_de_analise.data_inicial,
    endDate: data.periodos_de_analise.data_final,
    maxInterval: data.periodos_de_analise.intervalo_maximo,
  };
}

const HIDDEN_SEQUENTIAL_VARIABLES = ['etc', 'graus-dia'];

export function transformGetWBSequentialGraphResponse(
  response: GetSequentialGraphResponse,
): SequentialGraph {
  return toWaterBalanceSeries(
    response.data,
    (variable) => HIDDEN_SEQUENTIAL_VARIABLES.includes(variable.toLowerCase()),
  );
}
